export default [{
  path: '/administracao/agendamentos-automaticos',
  component: () => import('@/views/Index'),
  children: [
    {
      name: 'Agendamentos Automáticos',
      path: '',
      component: () => import('@/views/agendamentosAutomaticos/Index.vue'),
      meta: {
        requiresAuth: true,
        admin: true,
        routeReleasedForLite: true,
        breadcrumb: [
            { name: 'Administração', path: '/administracao' },
            { name: 'Agendamentos Automáticos'}
        ]
      }
    }
  ]
}]